<template>
    <div class="jphomepage">
        <homepage type="2"></homepage>
    </div>
</template>
<script>
import homepage from "./homepage";
export default {
      components: {homepage},
  data() {
    return {
    
    };
  },
  created() {
    
  },
  methods: {
  }
};
</script>
<style lang="less">
.jphomepage{
    height: 100%;
}
</style>